import { useTheme } from '@shopify/polaris-viz-core';
import styles from './TooltipTitle.scss.js';
import { jsx } from 'react/jsx-runtime';

function TooltipTitle({
  children,
  theme,
  color
}) {
  const selectedTheme = useTheme(theme);
  return /*#__PURE__*/jsx("p", {
    className: styles.Title,
    style: {
      color: color !== null && color !== void 0 ? color : selectedTheme.tooltip.titleColor
    },
    children: children
  });
}

export { TooltipTitle };
